import { ASSESSMENT } from '../../Assessment/constants/api'

export const ASSESSMENT_AMENDMENT = `${ASSESSMENT}amendment/` as const
export const ASSESSMENT_AMENDMENT_ALL = `${ASSESSMENT_AMENDMENT}all` as const
export const ASSESSMENT_AMENDMENT_ALL_UPDATED = `${ASSESSMENT}all/updated` as const
export const ASSESSMENT_AMENDMENT_PUBLISH = `${ASSESSMENT_AMENDMENT}publish` as const
export const ASSESSMENT_MARK_CHANGE_STATUS = `${ASSESSMENT}change/status` as const
export const ASSESSMENT_MARKS_GENERATE = `${ASSESSMENT}teacher/generate-mark-list` as const
export const ASSESSMENT_ZIP_UPLOADS = `${ASSESSMENT}zip-uploads` as const
export const ASSESSMENT_MODERATOR_FORM_BULK = `${ASSESSMENT}moderator-form` as const
export const ASSESSMENT_MODERATOR_FORM = `${ASSESSMENT}internal-moderator-form` as const
export const ASSESSMENT_CU_MARK_LIST = `${ASSESSMENT}cu/mark-list` as const
